module.exports = __webpack_public_path__ + "innistrad.jpg?81bb2bded33c5b48603bba295e8e5792";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/innistrad.jpg
// module id = 51
// module chunks = 0